export default {
  archive({
    rootGetters, dispatch,
  }, id) {
    rootGetters['menuGeneral/getRepository'].archive(id)
      .then(() => {
        dispatch('menuGeneral/table/fetch', null, { root: true });
      });
  },
  unarchive({
    rootGetters, dispatch,
  }, id) {
    rootGetters['menuGeneral/getRepository'].unarchive(id)
      .then(() => {
        dispatch('menuGeneral/table/fetch', null, { root: true });
      });
  },
};
